module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.type == 'info') ? _c('div', {
    staticClass: "ep-alert"
  }, [_vm._m(0), _c('span', {
    staticClass: "ep-con-txt  ep-blue"
  }, [_vm._t("default")], 2)]) : _vm._e(), _vm._v(" "), (_vm.type == 'success') ? _c('div', {
    staticClass: "ep-alert"
  }, [_vm._m(1), _c('span', {
    staticClass: "ep-con-txt  ep-green"
  }, [_vm._t("default")], 2)]) : _vm._e(), _vm._v(" "), (_vm.type == 'error') ? _c('div', {
    staticClass: "ep-alert"
  }, [_vm._m(2), _c('span', {
    staticClass: "ep-con-txt  ep-red"
  }, [_vm._t("default")], 2)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ep-con-img"
  }, [_c('img', {
    attrs: {
      "src": require("../static/loading.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ep-con-img"
  }, [_c('img', {
    attrs: {
      "src": require("../static/pass.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ep-con-img"
  }, [_c('img', {
    attrs: {
      "src": require("../static/prompt.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d6ad5ba","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iexplore/components/alert/src/Alert.vue
// module id = 1199
// module chunks = 2